import { createContext } from 'react'

const rosoomContext = createContext()

export default rosoomContext
